// extracted by mini-css-extract-plugin
export default {"root":"MediaPlayerClassicWin98_root__GbfiF","content":"MediaPlayerClassicWin98_content__ZjAEc","windowContent":"MediaPlayerClassicWin98_windowContent__u+Lbh"};